<template>
  <TimeFromSelect
    :availableTimes="availableTimes"
    :timeFrom="timeFrom"
    @update:timeFrom="timeFrom = $event"
  />
</template>

<script>
import TimeFromSelect from '@features/TimeFrom.vue'
import timeFromMixins from '@apps/order-form/src/mixins/timeFrom'

export default {
  name: 'TimeFrom',
  components: { TimeFromSelect },
  mixins: [timeFromMixins],
}
</script>
